import { ActionIcon, Box } from '@mantine/core'
import dayjs from 'dayjs'

import { toast } from 'src/components/Overlays/Toast/Toast'
import IconCopy from 'src/icons/IconCopy'
import { cn } from 'src/utils'

const VoiceAgentRow = ({ voiceAgent, setSelectedVoiceAgent }) => {
  return (
    <Box
      key={voiceAgent.voiceAgentId}
      className={cn(
        'border-bg-doubleNickel-gray-600 grid min-h-10 cursor-pointer grid-cols-7 items-center px-2 py-1 text-xs text-doubleNickel-gray-500 hover:bg-doubleNickel-gray-100'
      )}
      onClick={() => {
        setSelectedVoiceAgent(voiceAgent)
      }}
    >
      <div>
        <ActionIcon
          variant="subtle"
          size={14}
          color="gray"
          onClick={(e) => {
            e.stopPropagation()
            navigator.clipboard.writeText(voiceAgent.voiceAgentId)
            toast('Voice agent ID copied to clipboard', 'success')
          }}
        >
          <IconCopy className="fill-none stroke-doubleNickel-gray-500" />
        </ActionIcon>
      </div>
      <div>{voiceAgent.name}</div>
      <div>{voiceAgent.type === 'VOE' ? 'VoE' : 'Applicant'}</div>
      <div>{voiceAgent.voice}</div>
      <div>{voiceAgent.direction === 'INBOUND' ? 'Inbound' : 'Outbound'}</div>
      <div
        className={cn(
          voiceAgent.status === 'ACTIVE'
            ? 'text-doubleNickel-success-500'
            : 'text-doubleNickel-error-500'
        )}
      >
        {voiceAgent.status === 'ACTIVE' ? 'Active' : 'Inactive'}
      </div>
      <div>{dayjs(voiceAgent.updatedAt).format('MM/DD/YYYY hh:mm A')}</div>
    </Box>
  )
}

export default VoiceAgentRow
